import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { AuthenticationState } from "react-aad-msal";
import Wrapper from "../wrapper/Wrapper";
import { Container, Row, Col, Button } from "react-bootstrap";
import MediaQuery from 'react-responsive';
import { accountHelper, checkoutStep, formatter } from "../../util";
import { StateBootstrapButton as StateButton, RouterStateButton } from "../forms/elements/Button";
import { Summary, DeliveryMethod, AddressInfo, PaymentInfo, PersonalInfo, CompletionModal, BillingAddress } from "../cart/CheckoutHelpers"; // import { Debug } from '../forms/Debug';
// Redux

import { accountDuck } from "../../ducks/account";
var accountOperations = accountDuck.operations; // Form Elements

import { Form } from 'formik'; // Validation schema

import { AddressValidationModal } from "../cart/CheckoutHelpers/AddressValidation";
import { formikEnhancer } from "../cart/formik/formikEnhancer";
import { GlobalStateProvider } from "../cart/tokenex/InMemoryState";

var OfflineCheckout = function OfflineCheckout(props) {
  var _props$cost = props.cost,
      cost = _props$cost === void 0 ? {
    Total: 1
  } : _props$cost,
      _props$cart = props.cart,
      cart = _props$cart === void 0 ? [] : _props$cart,
      _props$paypal = props.paypal,
      paypal = _props$paypal === void 0 ? {} : _props$paypal,
      _props$destructuredCa = props.destructuredCart,
      destructuredCart = _props$destructuredCa === void 0 ? {} : _props$destructuredCa,
      _props$deliveryMethod = props.deliveryMethod,
      deliveryMethod = _props$deliveryMethod === void 0 ? {} : _props$deliveryMethod,
      _props$guest = props.guest,
      guest = _props$guest === void 0 ? true : _props$guest,
      _props$resetGoToCheck = props.resetGoToCheckout,
      resetGoToCheckout = _props$resetGoToCheck === void 0 ? function () {
    return console.log("resetGoToCheckout");
  } : _props$resetGoToCheck,
      _props$setTip = props.setTip,
      setTip = _props$setTip === void 0 ? function () {
    return console.log("checkoutPage set");
  } : _props$setTip,
      values = props.values,
      _props$submitHandler = props.submitHandler,
      submitHandler = _props$submitHandler === void 0 ? function () {
    return console.log("submitHandler");
  } : _props$submitHandler,
      _props$handleBackToCa = props.handleBackToCart,
      handleBackToCart = _props$handleBackToCa === void 0 ? function () {
    return console.log("handleBackToCart");
  } : _props$handleBackToCa,
      _props$getAccountAddr = props.getAccountAddress,
      getAccountAddress = _props$getAccountAddr === void 0 ? function () {
    return console.log('getAccountAddress');
  } : _props$getAccountAddr,
      _props$postAccountAdd = props.postAccountAddress,
      postAccountAddress = _props$postAccountAdd === void 0 ? function () {
    return console.log('postAccountAddress');
  } : _props$postAccountAdd,
      _props$receiveAddress = props.receiveAddress,
      receiveAddress = _props$receiveAddress === void 0 ? function () {
    return console.log('receiveAddress');
  } : _props$receiveAddress,
      setFieldTouched = props.setFieldTouched,
      errors = props.errors,
      deliveryFail = props.deliveryFail,
      _props$getGiftCardSch = props.getGiftCardSchema,
      getGiftCardSchema = _props$getGiftCardSch === void 0 ? function () {
    return "";
  } : _props$getGiftCardSch,
      schema = props.schema,
      _props$giftCardInfo = props.giftCardInfo,
      giftCardInfo = _props$giftCardInfo === void 0 ? [] : _props$giftCardInfo,
      _props$removeAllGiftC = props.removeAllGiftCards,
      removeAllGiftCards = _props$removeAllGiftC === void 0 ? function () {
    return "";
  } : _props$removeAllGiftC,
      location = props.location,
      setRetail = props.setRetail,
      isFood = props.isFood,
      isCatering = props.isCatering,
      isRetail = props.isRetail,
      shippingMode = props.shippingMode,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$getSavedCredit = props.getSavedCreditCards,
      getSavedCreditCards = _props$getSavedCredit === void 0 ? function () {
    return "";
  } : _props$getSavedCredit,
      setFieldValue = props.setFieldValue,
      accountInfo = props.accountInfo,
      _props$authentication = props.authenticationState,
      authenticationState = _props$authentication === void 0 ? AuthenticationState.Unauthenticated : _props$authentication,
      addresses = props.addresses,
      addressBook = props.addressBook,
      validateAddress = props.validateAddress,
      assigned = props.assigned,
      customerList = props.customerList;
  var retailMethod = deliveryMethod.retailDeliveryMode || shippingMode;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      activeCategoryIndex = _useState2[0],
      setActiveCategoryIndex = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      sections = _useState4[0],
      setSections = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      accountInfoModified = _useState6[0],
      setAccountInfo = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      hasFlipped = _useState8[0],
      setHasFlipped = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      addressValidation = _useState10[0],
      setAddressValidation = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      addressDisable = _useState12[0],
      setAddressDisable = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      externalPayment = _useState14[0],
      setExternalPayment = _useState14[1];

  var _useState15 = useState('card'),
      _useState16 = _slicedToArray(_useState15, 2),
      paymentType = _useState16[0],
      setPaymentType = _useState16[1];

  useEffect(function () {
    constructSections();
    resetGoToCheckout();
  }, []);
  var initialTotal = cost.Total;
  useEffect(function () {
    if (cart.length && !hasFlipped) {
      setHasFlipped(true);
      checkoutStep({
        actionField: {
          'step': 1,
          'option': 'Checkout Initiated'
        },
        cartInfo: cart
      });
    }
  }, [cart, hasFlipped]);
  useEffect(function () {
    if (assigned) {
      var assignedUser = customerList[0];
      var _fields = {
        'firstName': assignedUser.FirstName,
        'lastName': assignedUser.LastName,
        'email': assignedUser.EmailAddress,
        'phone': assignedUser.PrimaryPhone ? formatPhoneNumber(assignedUser.PrimaryPhone) : ''
      };
      Object.keys(_fields).forEach(function (key) {
        setFieldValue(key, _fields[key]);
      });
      setAccountInfo(true);
    }
  }, [assigned]);

  var handleSubmitCart = function handleSubmitCart(formikValues) {
    var payload = {
      paymentInfo: {
        "billingmethod": formikValues.paymentMethod,
        "billingaccountid": 0,
        "usertype": "guest",
        "firstname": formikValues.firstName,
        "lastname": formikValues.lastName,
        "emailaddress": formikValues.email,
        "contactid": assigned ? customerList[0].AccountNumber : ''
      },
      cardInfo: {}
    };

    if (formikValues.paymentMethod === "creditcard") {
      var _formikValues$expDate;

      var expDate = (formikValues === null || formikValues === void 0 ? void 0 : (_formikValues$expDate = formikValues.expDate) === null || _formikValues$expDate === void 0 ? void 0 : _formikValues$expDate.split("/")) || [];
      var year = parseInt("20" + expDate[1]);
      var month = parseInt(expDate[0]);
      payload.cardInfo = _objectSpread(_objectSpread({}, payload.cardInfo), {}, {
        contactnumber: formikValues.phone,
        cardnumber: formikValues.cardNumber,
        expiryyear: isNaN(year) ? "" : year,
        expirymonth: isNaN(month) ? "" : month,
        cvv: formikValues.cvv,
        zip: formikValues.billingZip,
        streetAddress: formikValues.billingStreetAddress,
        state: formikValues.billingState,
        city: formikValues.billingCity
      });

      if (isRetail) {
        payload.cardInfo = _objectSpread(_objectSpread({}, payload.cardInfo), {}, {
          billingaccountid: 1,
          "cardtype": "CC",
          "savecarddetails": formikValues.savecarddetails || false,
          "WPTokenizedPAN": formikValues.wptokenizeedpan || "",
          "cardnumber": formikValues.wptokenizeedpan ? "" : formikValues.cardNumber
        });
      }
    }

    submitHandler(payload);
  };

  var layout = {
    background: "white",
    padding: "medium"
  };

  var addressValidationChange = function addressValidationChange() {
    //if(validateAddress) {
    setAddressValidation(!addressValidation); //}
  };

  var handleRetail = function handleRetail(newIndex) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return "";
    };
    var addressInfo = {
      "name": "",
      "firstName": values ? values.firstName : "",
      "lastName": values ? values.lastName : "",
      "address1": values ? values.retailStreetAddress || values.shippingStreetAddress : "",
      "address2": values ? values.retailStreetAddress2 || values.shippingStreetAddress2 : "",
      "city": values ? values.retailCity || values.shippingCity : "",
      "state": values ? values.retailState || values.shippingState : "",
      "zipPostalCode": values ? values.retailZip || values.shippingZip : "",
      "country": "US",
      "countryCode": "US",
      "isPrimary": false,
      "email": values ? values.email : "",
      "contactid": assigned ? customerList[0].AccountNumber : ''
    };
    setAddressDisable(true);
    cb();
    setRetail(addressInfo, retailMethod).then(function (res) {
      setActiveCategoryIndex(newIndex);
    }).catch(function (err) {
      return console.log(err);
    });
  };

  var constructSections = function constructSections() {
    var sections = ["1method"];
    sections.push("2guest");
    sections.push("6retail");

    if (isRetail) {
      sections.push("6retail");
      setFieldValue("isRetail", "true");
    } else {
      setFieldValue("isRetail", "false");
    }

    sections.push("7payment");
    setSections(sections.sort());
  };

  var handleContinue = function handleContinue(index, fields, invalidArg) {
    var func = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : setActiveCategoryIndex;
    var retry = false;
    var invalid = invalidArg;
    fields.forEach(function (field) {
      setFieldTouched(field, true);

      if (Boolean(errors[field])) {
        invalid = true;
      }
    });

    if (invalid && retry) {
      retry = false;
      invalid = false;
      fields.forEach(function (field) {
        setFieldTouched(field, true, false);

        if (Boolean(errors[field])) {
          invalid = true;
        }
      });
    }

    if (!invalid) {
      return func(index);
    } else {
      console.log("ERRORS WERE FOUND", fields, errors);
      return false;
    }
  };

  var personalInfoFields = ["firstName", "lastName", "email", "phone"];
  var deliveryFields = ["shippingStreetAddress", "shippingStreetAddress2", "shippingCity", "shippingState", "shippingZip", "shippingOther"];
  var retailFields = ["retailStreetAddress", "retailStreetAddress2", "retailCity", "retailState", "retailZip", "retailOther"];

  if (props.authenticationState === AuthenticationState.Authenticated) {
    deliveryFields.push('saveDeliveryAddress');
    retailFields.push('saveDeliveryAddress');
  }

  var fields = personalInfoFields;
  var sectionsLength = sections.length;
  var paymentActive = false;
  var retailActive = true;

  if (sections.indexOf("6retail") >= 0) {
    fields = fields.concat(retailFields);
    sectionsLength = sections.indexOf("6retail");
  }

  if (paymentActive) {
    sectionsLength = 1;
  }

  var AKHIcheck = Boolean(isRetail) && Boolean(values.retailState == "AK" || values.retailState == "HI") && Boolean(!retailMethod.includes("alaska"));
  var AUTHSTATE = props.authenticationState === AuthenticationState.Authenticated;
  var retailIndex = sections.indexOf("6retail");
  var dispatchIndex = sections.indexOf("3dispatch"); //(sections.indexOf("3paypalform") >= 0) ?  sections.indexOf("3paypalform") +1 : sections.indexOf("3retail");

  var paymentSectionIndex = sections.indexOf("7payment");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(CompletionModal, props), /*#__PURE__*/React.createElement(AddressValidationModal, _extends({}, props, {
    hideAddressValidate: function hideAddressValidate() {
      return addressValidationChange(false);
    },
    addressValidation: addressValidation,
    handleRetail: handleRetail,
    retailIndex: retailIndex
  })), /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: "cb-cart cb-checkout"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "8",
    className: "cb-cart__content-wrapper"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "cb-cart__h2 cb-checkout__header-text"
  }, "Checkout")), /*#__PURE__*/React.createElement(RouterStateButton, {
    href: "/shop/cart",
    className: "cb-button-unstyled",
    onClick: handleBackToCart
  }, "Back to cart"))), /*#__PURE__*/React.createElement(DeliveryMethod, _extends({
    cart: cart,
    deliveryMethod: deliveryMethod,
    index: sections.indexOf("1method"),
    activeCategoryIndex: activeCategoryIndex,
    shippingMode: shippingMode
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: sections.indexOf("1method"),
    activeCategoryIndex: activeCategoryIndex,
    functionName: handleContinue,
    editFunction: setActiveCategoryIndex,
    fields: [],
    editHide: true
  })), /*#__PURE__*/React.createElement(React.Fragment, null, sections.indexOf("2guest") !== -1 ? /*#__PURE__*/React.createElement(PersonalInfo, _extends({
    className: "",
    index: sections.indexOf("2guest"),
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    activeCategoryIndex: activeCategoryIndex,
    setExternalPayment: setExternalPayment,
    externalPayment: externalPayment,
    setPaymentType: setPaymentType,
    paymentType: paymentType,
    isOfflineStore: true
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: sections.indexOf("2guest"),
    activeCategoryIndex: activeCategoryIndex,
    functionName: function functionName(a, b) {
      checkoutStep({
        actionField: {
          'step': 2,
          'option': 'Contact Initiated'
        },
        cartInfo: cart
      });
      handleContinue(a, b);
    },
    editFunction: setActiveCategoryIndex,
    fields: personalInfoFields
  })) : null, sections.indexOf("6retail") !== -1 && /*#__PURE__*/React.createElement(AddressInfo, _extends({
    index: sections.indexOf("6retail"),
    defaultActive: retailActive,
    activeCategoryIndex: activeCategoryIndex,
    retailDeliverytype: retailMethod,
    AKHIcheck: AKHIcheck,
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    showRetail: true,
    addressDisable: addressDisable,
    isOfflineStore: true
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: sections.indexOf("6retail"),
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: true,
    section: "Address retail",
    functionName: function functionName(a, b) {
      return handleContinue(a, b, undefined, addressValidationChange);
    },
    editFunction: function editFunction(index) {
      setActiveCategoryIndex(index);
      setAddressDisable(false);
    },
    fields: fields,
    forceDisabled: AKHIcheck
  })), sections.indexOf("7payment") !== -1 && /*#__PURE__*/React.createElement(GlobalStateProvider, null, /*#__PURE__*/React.createElement(PaymentInfo, _extends({
    index: paymentSectionIndex,
    activeCategoryIndex: retailIndex <= -1 && dispatchIndex <= -1 && activeCategoryIndex < paymentSectionIndex ? paymentSectionIndex : activeCategoryIndex,
    shippingInfo: deliveryFields,
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE,
    showGiftCard: true,
    setExternalPayment: setExternalPayment,
    setPaymentType: setPaymentType,
    externalPayment: externalPayment,
    paymentType: paymentType,
    isOfflineStore: true,
    cost: cost,
    isFood: false,
    isCatering: false,
    fields: ["cardNumber", "expDate", "cvv"],
    editFunction: setActiveCategoryIndex,
    functionName: function functionName(a, b) {
      checkoutStep({
        actionField: {
          'step': 3,
          'option': values.paymentMethod
        },
        cartInfo: cart
      });
      handleContinue(paymentSectionIndex + 1, ["ccfirstSix"]);
    }
  }, props))), /*#__PURE__*/React.createElement(BillingAddress, _extends({
    index: paymentSectionIndex + 1,
    activeCategoryIndex: activeCategoryIndex,
    shippingInfo: deliveryFields,
    accountInfoModified: accountInfoModified,
    AUTHSTATE: AUTHSTATE
  }, props), /*#__PURE__*/React.createElement(SectionButton, {
    index: paymentSectionIndex + 1,
    activeCategoryIndex: activeCategoryIndex,
    functionName: function functionName(a, b) {
      checkoutStep({
        actionField: {
          'step': 4,
          'option': values.paymentMethod
        },
        cartInfo: cart
      });
      handleContinue(a, b);
    },
    editFunction: setActiveCategoryIndex,
    fields: ["billingStreetAddress", "billingCity", "billingState", "billingZip", "billingOther"]
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "4",
    className: "cb-cart__cost-wrapper"
  }, /*#__PURE__*/React.createElement(Summary, _extends({
    cost: _objectSpread({}, cost),
    placeDisabled: activeCategoryIndex < sectionsLength,
    setTip: setTip,
    isOfflineStore: true
  }, props))))))));
};

export var SectionButton = function SectionButton(_ref) {
  var activeCategoryIndex = _ref.activeCategoryIndex,
      _ref$defaultActive = _ref.defaultActive,
      defaultActive = _ref$defaultActive === void 0 ? false : _ref$defaultActive,
      index = _ref.index,
      _ref$section = _ref.section,
      section = _ref$section === void 0 ? '' : _ref$section,
      functionName = _ref.functionName,
      editFunction = _ref.editFunction,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      forceDisabled = _ref.forceDisabled,
      loading = _ref.loading,
      editHide = _ref.editHide;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__button-wrapper"
  }, //activeCategoryIndex === index || 
  defaultActive && activeCategoryIndex < index + 1 && /*#__PURE__*/React.createElement(StateButton, {
    type: "button",
    className: "cb-button-primary",
    disabled: forceDisabled,
    loading: loading,
    onClick: function onClick() {
      return functionName(index + 1, fields);
    }
  }, "Save & Continue"), activeCategoryIndex >= index + 1 && !editHide && /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      return editFunction(index);
    }
  }, "Edit"));
};
export default formikEnhancer(OfflineCheckout);